// Stamps the club on the cart so checkout, the order and its email show that club.
// One club per order: a cart holding another club's products is cleared first.
(function () {
  var host = document.querySelector('[data-club-cart]');
  if (!host) return;

  var handle = host.dataset.clubHandle || '';
  var name = host.dataset.clubName || '';
  var logo = host.dataset.clubLogo || '';
  if (!handle) return;

  // Each club has its own cart, so a leftover cart from another club is emptied on arrival.
  (function dropForeignCart() {
    var root = (host.dataset.shopDomain || '').replace(/^www\./, '');
    var at = location.hostname;
    var onClubAddress = root && at !== root && at !== 'www.' + root && at.slice(-(root.length + 1)) === '.' + root;
    var here = onClubAddress ? at.slice(0, -(root.length + 1)) : handle;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartClub = cart.attributes && cart.attributes._club;
        if (!cart.item_count || !cartClub || cartClub === here) return;
        // Once per visit at most: if the clear did not take, reloading again would not help.
        try {
          if (sessionStorage.getItem('snc:foreign-cart') === cart.token) return;
          sessionStorage.setItem('snc:foreign-cart', cart.token);
        } catch (e) {
          return;
        }
        return fetch('/cart/clear.js', { method: 'POST' })
          .then(function (r) {
            if (!r.ok) throw new Error('clear failed');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { Club: '', _club: '', _club_logo: '' } }),
            });
          })
          .then(function () { location.reload(); });
      })
      .catch(function () {
      });
  })();

  // The crest goes as a URL: the order status page and email cannot read metaobjects.
  var payload = { attributes: { Club: name || handle, _club: handle, _club_logo: logo } };
  var body = JSON.stringify(payload);
  var stamped = false;

  function stamp() {
    if (stamped) return;
    stamped = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    }).catch(function () {
      stamped = false;
    });
  }

  // Legal pages name no club, so stamp the cart before following a link from the club footer.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-club-legal]');
    if (!link || host.dataset.cartClub === handle) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    var go = function () { location.href = link.href; };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    }).then(go, go);
  });

  document.addEventListener('cart:refresh', stamp);

  // Plain form posts navigate away before fetch can finish, so send it as a beacon.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (stamped) return;
      stamped = true;
      var sent = false;
      if (navigator.sendBeacon) {
        sent = navigator.sendBeacon('/cart/update.js', new Blob([body], { type: 'application/json' }));
      }
      if (!sent) {
        stamped = false;
        stamp();
      }
    },
    true,
  );

  function toast(message) {
    var el = document.createElement('div');
    el.className = 'snc-club-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-leaving');
      setTimeout(function () { el.remove(); }, 300);
    }, 3200);
  }

  // Called before an add. Resolves at once when the cart is empty or already this club's, else after clearing it.
  window.sncClubCartClear = function (itemClubHandle) {
    if (!itemClubHandle) return Promise.resolve();
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartClubHandle = cart.attributes && cart.attributes._club;
        if (!cartClubHandle || cartClubHandle === itemClubHandle) return;
        if (!cart.item_count) return;
        var cartClubName = (cart.attributes && cart.attributes.Club) || cartClubHandle;
        return fetch('/cart/clear.js', { method: 'POST' }).then(function () {
          toast('Your ' + cartClubName + ' cart was cleared to shop a different club.');
        });
      })
      .catch(function () {
        // A failed check must not block a real add.
      });
  };
})();
